const NAME = "PERIODS_FOR_OBJECTIVES";

export default NAME;
